module.exports = __webpack_public_path__ + "static/the-restoration-11-carthage-01-c6e2287707f9d24a35b17b062b2ca439.png";